import { assertNever } from 'owa-assert';
import { FolderSelectorError } from '../store/schema/FolderSelectorError';
import { getOwaCommonStrings } from 'owa-strings/owa-common-strings';
import { getStore } from '../store/store';
import { EmptyStateProps } from 'owa-empty-state/lib/components/EmptyState';

export function isAnyError(): boolean {
    return getStore().error !== FolderSelectorError.None;
}

export function isCreatingFolderRelatedError(): boolean {
    const { error } = getStore();

    return (
        error === FolderSelectorError.CreatingNewFolder ||
        error === FolderSelectorError.FolderAlreadyExists
    );
}

export function isLoadingFolderRelatedError(): boolean {
    const { error } = getStore();

    return (
        error === FolderSelectorError.UnableToLoadFileProviders ||
        error === FolderSelectorError.UnableToOpenFolder
    );
}

export function getErrorString(): string | null {
    const { error } = getStore();

    switch (error) {
        case FolderSelectorError.CreatingNewFolder:
            return getOwaCommonStrings().failedToCreateNewFolderErrorText;
        case FolderSelectorError.FolderAlreadyExists:
            return getOwaCommonStrings().folderNameExistsErrorText;
        case FolderSelectorError.UnableToOpenFolder:
            return getOwaCommonStrings().failedToLoadFoldersErrorText;
        case FolderSelectorError.UnableToLoadFileProviders:
            // TODO: zorauf: Localize the string
            return "We're having trouble loading your folders";
        case FolderSelectorError.None:
            return null;
        default:
            return assertNever(error);
    }
}

export function getErrorEmptyStateProps(): EmptyStateProps | null {
    const { error } = getStore();

    switch (error) {
        case FolderSelectorError.UnableToOpenFolder:
        case FolderSelectorError.UnableToLoadFileProviders:
            return {
                icon: require('owa-empty-state/lib/svg/colored/loadingError.svg'),
                mainMessage: getErrorString(),
            };
        case FolderSelectorError.CreatingNewFolder:
        case FolderSelectorError.FolderAlreadyExists:
        case FolderSelectorError.None:
            return null;
        default:
            return assertNever(error);
    }
}
